// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__vTlMh","inner":"Header_inner__1ndfK","title":"Header_title__M5bZg","logout":"Header_logout__2v34M"};